import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center gap-4">
      <h1 className="text-5xl font-bold text-adobe-dark">404</h1>
      <p className="text-adobe-muted">페이지를 찾을 수 없습니다.</p>
      <Link to="/" className="text-primary hover:underline">
        홈으로 돌아가기
      </Link>
    </div>
  );
}
